import React from "react";
import {
  AnalyticsIcon,
  ChartLineIcon,
  fmtCurrency,
  fmtPercent,
} from "./shared";
import { colors } from "../../global";

export const AnalysisSection = ({ meta, displayPct, absSavings }) => (
  <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-8">
    {/* Cost Analysis Comparison */}
    <div className="bg-white rounded-xl shadow-lg border border-gray-200 p-6">
      <h3 className="text-lg font-semibold text-gray-800 mb-4 flex items-center gap-3">
        <div style={{ color: colors.primary }}>
          <ChartLineIcon />
        </div>
        Cost Analysis Comparison
      </h3>
      <div className="mt-4 text-sm text-gray-600">
        {typeof displayPct === "number" ? (
          <>
            {Math.abs(displayPct) === 0 && (
              <span>Analysis shows no significant change in costs.</span>
            )}
            {meta.state !== "worse" && (
              <span>
                Analysis shows <strong>{fmtPercent(displayPct, 2)}</strong> cost
                reduction potential.
              </span>
            )}
            {meta.state === "worse" && (
              <span>
                Analysis indicates a{" "}
                <strong>{fmtPercent(Math.abs(displayPct), 2)}</strong> cost
                increase risk.
              </span>
            )}
          </>
        ) : (
          <span>Insufficient data to compute reduction/increase.</span>
        )}
      </div>
    </div>

    {/* Savings Breakdown */}
    <div className="bg-white rounded-xl shadow-lg border border-gray-200 p-6">
      <h3 className="text-lg font-semibold text-gray-800 mb-4 flex items-center gap-3">
        <div style={{ color: colors.success }}>
          <AnalyticsIcon />
        </div>
        Savings Breakdown
      </h3>
      <div className="mt-4 space-y-2">
        <div className="flex items-center gap-2">
          <div
            className="w-3 h-3 rounded-full"
            style={{
              backgroundColor:
                meta.state === "worse" ? colors.error : colors.success,
            }}
          />
          <span className="text-sm">
            {meta.state === "worse" ? "Cost Increase: " : "Cost Reduction: "}
            {typeof displayPct === "number"
              ? fmtPercent(Math.abs(displayPct), 2)
              : "—"}
          </span>
        </div>
        <div className="flex items-center gap-2">
          <div
            className="w-3 h-3 rounded-full"
            style={{ backgroundColor: colors.gray }}
          />
          <span className="text-sm">
            Remaining Cost Share:{" "}
            {typeof displayPct === "number"
              ? fmtPercent(
                  100 - Math.max(0, Math.min(100, Math.max(0, displayPct)))
                )
              : "—"}
          </span>
        </div>
        <div className="flex items-center gap-2">
          <div
            className="w-3 h-3 rounded-full"
            style={{ backgroundColor: colors.mutedBlue }}
          />
          <span className="text-sm">
            {meta.state === "worse"
              ? "Extra Cost Amount: "
              : "Savings Amount: "}
            {fmtCurrency(Math.abs(absSavings))}
          </span>
        </div>
      </div>
    </div>
  </div>
);
